import React from 'react';

import JobList from 'components/jobs/list';
import NewSalaryChartComponent from 'components/newSalaryChartComponent';
import {
  CHART_TYPES,
  ENTITY,
  mapSalaryChartItemsForTypeA,
  PAGE,
} from 'components/newSalaryChartComponent/chartUtils';
import { CMP_SUBPAGES } from 'utils/constant';

import Table from '../../components/customTable';

const columnsConfig = {
  rank: {
    columnName: 'Rank',
    defaultSortDirection: 'asc',
  },
  title: {
    columnName: 'Industry',
  },
  medianDisplay: {
    columnName: 'Average Salary',
    customSortByField: 'median',
  },
  hourlyRateDisplay: {
    columnName: 'Hourly Rate',
    customSortByField: 'median',
  },
};

const SalariesByIndustries = ({
  basicData,
  salayByIndustryContentBlurb,
  salaryByIndustry,
  jobListDismiss,
  titleIndexes,
  jobsByLocation,
  asTable,
  src,
}) => {
  const tableHeaders = () => {
    return (
      <thead>
        <tr className="z-px-20 z-py-10 d-flex w-100">
          <th className="d-none d-md-block col-md-1 text-center px-0">
            <span className="font-weight-600 greyLabel font-14">Rank</span>
          </th>
          <th className="col-4 px-0">
            <span className="font-weight-600 greyLabel font-14">Industry</span>
          </th>
          <th className="col-8 col-md-4 text-center">
            <span className="font-weight-600 greyLabel font-14">{`Average ${basicData.jobTitle} Salary`}</span>
          </th>
          <th className="d-none d-md-block col-md-3 justify-content-center pl-4">
            <span className="font-weight-600 greyLabel font-14">{`${basicData.jobTitle} Salary Range`}</span>
          </th>
        </tr>
      </thead>
    );
  };

  return (
    <div className="d-flex flex-column flex-lg-row justify-content-between">
      <div>
        <div className="w-730">
          <h2 className="brandonH2 mb-5">
            {`${basicData.jobTitle} salary by industry`}
          </h2>

          <div
            className="content-blurb mb-5"
            dangerouslySetInnerHTML={{
              __html: salayByIndustryContentBlurb,
            }}
          />
        </div>

        {asTable ? (
          <>
            <h3 className="zp-title-h3 text-capitalize z-mb-24">
              {`Highest paying industries for ${basicData.jobTitlePlural?.toLowerCase?.()}`}
            </h3>
            <Table
              columnConfig={columnsConfig}
              columnWidthBalanced={false}
              bodyData={mapSalaryChartItemsForTypeA(
                salaryByIndustry,
                ENTITY.INDUSTRY,
                PAGE.JOB_TITLE,
                false,
                '',
                '',
                true
              )}
              defaultRowsDisplay={10}
              scrollOnMobile
            />
          </>
        ) : (
          <NewSalaryChartComponent
            chartType={CHART_TYPES.TYPE_A}
            salaryChartItems={mapSalaryChartItemsForTypeA(
              salaryByIndustry,
              ENTITY.INDUSTRY,
              PAGE.JOB_TITLE,
              false,
              '',
              '',
              true
            )}
            listSizeValue={salaryByIndustry.length}
            showSignUp
            tableHeaders={tableHeaders}
            tableHeaderTitleContent={
              <h3 className="zp-title-h3 text-capitalize mb-4">
                Highest Paying Industries For {basicData.jobTitlePlural}
              </h3>
            }
          />
        )}
      </div>

      {!jobListDismiss && (
        <div className="z-mt-24 z-mt-lg-0">
          <JobList
            title={`High Paying ${basicData.jobTitle} Jobs`}
            jobsPageIndexable={titleIndexes.indexInfoOfJobsPage === 'INDEX'}
            origin={CMP_SUBPAGES.SALARY}
            initialPayload={{
              title: basicData.jobTitle,
              salary: basicData.percentile75thAverageAnnualSalary,
              locations: jobsByLocation,
            }}
            isRemote
            usingPaidAPI={true} // It will use paid job API everytime
            src={src}
          />
        </div>
      )}
    </div>
  );
};

export default SalariesByIndustries;
